"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rollbar = _interopRequireDefault(require("rollbar"));

var _config = _interopRequireDefault(require("../utils/config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const rollbar = new _rollbar.default({
  accessToken: _config.default.SOCKET_ROLLBAR_TOKEN,
  environment: _config.default.CURRENT_ENV
});

const errorLog = error => {
  rollbar.error(`Client: ${error}`);
};

var _default = {
  error: errorLog
};
exports.default = _default;
//# sourceMappingURL=logsHandler.js.map